import { Component, OnInit, ViewEncapsulation,ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { FilterMatchMode, LazyLoadEvent, MenuItem, SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
import { IGlobalSearchParam } from '../../../shared/models/Global-Search.model';
import { ClientRequisitionContactService } from '../../services';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ClientRequisitionContact } from '../../models';
import { VMSConstants } from '../../../shared/constants/vms-constants';
import * as fs from 'file-saver';
import { User} from '../../../auth/models';
import { SharedService } from '../../../shared/services/shared.service';
import { ClientRequisitionViewModalComponent } from './client-requisition-view-modal/client-requisition-view-modal.component';
import {DialogService} from 'primeng/dynamicdialog';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-client-requisition-contact',
  templateUrl: './client-requisition-contact.component.html',
  styleUrls: ['./client-requisition-contact.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService, ConfirmationService, MessageService]
})
export class ClientRequisitionContactComponent implements OnInit {
  isSearchLoading: boolean = false;
  showFilters:boolean;
  showSorting:boolean;
  matchModeOptions: SelectItem[];
  matchModeOptionsForDate: SelectItem[];
  matchModeOptionsForNumeric: SelectItem[];
  showAddRuleButton:boolean = false;
  pageNo: number =1;
  pageSize: number =10;
  oldPageNo: number =1;
  oldPageSize: number =10;
  totalRecords: number;
  loadEvent: LazyLoadEvent;
  filters;
  filterCondition: { fieldName: string; type: string; }[] =[];
  appliedFilters:{field:string,matchMode:string,value:string}[]=[];
  searchParam:IGlobalSearchParam;
  oldSortField:string = 'createdOn';
  oldSortOrder:string = 'desc';
  sortField:string = 'createdOn';
  sortOrder:string = 'desc';
  crcSearchSpinner = 'crcSearchSpinner';
  crcList: any;
  startSearch: boolean = false;
  dialogPosition = 'topright';
  isCrcAdd : boolean = false;
  crcForm:FormGroup;
  vendorCompanyList: any;
  clientCompanyList: any;
  loading: boolean = false;
  isCrcEdit : boolean = false;
  title: string = "";
  buttonLabel: string = "";
  contactEmail:string;
  isContactPhoneNumberValid:boolean=false;
  isContactPhoneUniqueNumbers:boolean=false;
  contactPhone:string;
  isCrcView : boolean = false;
  selectedCompanyId:number;
  isCompanyNameSelected:boolean = false;
  isCrcAvailability:boolean=false;
  loggedInUserProfile: User;
  ref: DynamicDialogRef;
  selectedGridMenuItem:any = null;
  items: MenuItem[];
  showToggle:boolean;
  isshowpaginator:boolean=true;
  statusValues:any;
  selectedStatusId:any="All";
  selectedStatus:any;
  allColumns = [
   { value: 'action', header: 'Action' },
   { value: 'clientCompanyName', header: 'Client Name' },
   { value: 'contactPerson', header: 'Contact Person' },
   { value: 'contactEmail', header: 'Contact Email' },
   { value: 'contactPhone', header: 'Contact Phone' },
   { value: 'isActive', header: 'Status' },
   { value: 'createdBy', header: 'Created By' },
   { value: 'createdOn', header: 'Created On' }
 ]

 selectedColumns = [
  { value: 'action', header: 'Action' },
  { value: 'clientCompanyName', header: 'Client Name' },
  { value: 'contactPerson', header: 'Contact Person' },
  { value: 'contactEmail', header: 'Contact Email' },
  { value: 'contactPhone', header: 'Contact Phone' },
  { value: 'isActive', header: 'Status' },
  { value: 'createdBy', header: 'Created By' },
  { value: 'createdOn', header: 'Created On' }
 ]
 @ViewChild('dt2', { static: true }) table: any;

  constructor(
    public datepipe: DatePipe,
    private spinner: NgxSpinnerService,
    private ClientRequisitionContactService:ClientRequisitionContactService,
    private dialogService: DialogService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private _fb: FormBuilder,
    public sharedService:SharedService,
    private _router: Router,
  ) { 
    this.showFilters = false;
    this.showSorting = false;
    this.spinner.show();
    setTimeout(() => {
        this.spinner.hide();
    }, 1000);
    /*this.items = [
     
      {
       label:'Edit',
       icon:'pi pi-fw pi-pencil',
       command: e => this.editCrcDetails(this.selectedGridMenuItem.contactId)
      },
      {
       label:'Delete',
       icon:'pi pi-fw pi-trash',
       command: e => this.deleteConfirm(this.selectedGridMenuItem.contactId)
      }
   ];*/
  }

  ngOnInit(): void {
    this.checkViewPermission();
    this.items = [];
    this.checkEditDeletePermission();
    const customFilterName = "custom-equals";
    const notEquals = "not-equals";
    const dateAfter = "date-after";
    const dateBefore = "date-before";
    
    this.matchModeOptions = [
      { label: "Custom Equals", value: customFilterName },
      { label: "Starts With", value: FilterMatchMode.STARTS_WITH },
      { label: "Contains", value: FilterMatchMode.CONTAINS }
    ];

    this.matchModeOptionsForDate = [
      { label: "Equals", value: customFilterName },
        { label: "Not Equals", value: notEquals },
        { label: "Greater Than", value: dateAfter },
        { label: "Less Than", value: dateBefore },
    ];

    this.matchModeOptionsForNumeric = [
      { label: "Custom Equals", value: customFilterName },
      { label: "Greater than or equal to", value: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
      { label: "Less than or equal to", value: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
    ];

    this.filterCondition=[
      {fieldName:"clientCompanyName",type:"basic"},
      {fieldName:"contactPerson",type:"basic"},
      {fieldName:"contactEmail",type:"basic"},
      {fieldName:"contactPhone",type:"basic"},
      {fieldName:"isActive",type:"basic"},
      {fieldName:"createdBy",type:"basic"},
      {fieldName:"createdOn",type:"date"},
    ];
    
    this.getLoggedInUserProfile();
    this.appliedFilters.push({ field:"globalfilter", matchMode:"equals", value:"0" });
    this.getClientRequisitionContact(); 
    this.statusValues=['All','Active',"Inactive"];
    this.InitialSetup();
    this.getClientCompanyList();
  }

  

  checkViewPermission()
   {
     var result = this.sharedService.checkPermission("Admin_View");
     if(!result)
     this._router.navigateByUrl('/login');
   }


  InitialSetup(){
    this.crcForm = this._fb.group({
      contactId: new FormControl(0),
      clientCompanyId: new FormControl(0,[Validators.required]),
      contactPerson: new FormControl("",[Validators.required]),
      //contactEmail: new FormControl("",[Validators.required]),
      contactEmail: ['', [Validators.required,Validators.pattern(VMSConstants.emailValidator)]],
      //contactPhone: new FormControl("",[Validators.required]),
      contactPhone: ['', [Validators.required,Validators.maxLength(14)]],
      isActive: new FormControl(true,[Validators.required]),
      createdBy: new FormControl(1),
      createdOn: new FormControl(new Date()),
      modifiedBy: new FormControl(""),
      modifiedOn: new FormControl("")
    })
  }

  loadCrc(event:LazyLoadEvent)
  { 
    this.loadEvent=event;
    if(event.first==0)
    {
      this.pageNo = 1;
    }
    else {
      this.pageNo=(event.first/event.rows)+1;
    }
    this.pageSize=event.rows;
    
    this.pageSize=event.rows;
    
    if((this.oldPageNo != this.pageNo) || (this.oldPageSize != this.pageSize))
    {
      this.applyFilter();
      this.getClientRequisitionContact();
    }
    this.oldPageNo = this.pageNo;
    this.oldPageSize = this.pageSize;
    this.filters=event.filters;
    if(this.filters["createdOn"]!= undefined)
    {
    if(this.filters["createdOn"][0].matchMode == "date-after")
    {
       this.showAddRuleButton = true;
    }
    else{
      this.showAddRuleButton = false;
    }
    }
    this.sortField=event.sortField;
    if(event.sortField === undefined || event.sortField === null)
    {
      this.sortField='createdOn';
    }
    if(event.sortOrder === 1)
    {
    this.sortOrder='desc';
    }
    if(event.sortOrder === -1)
    {
    this.sortOrder='asc';
    }
    /*if(this.sortField !== 'createdOn')
    {
      this.getAllClaimsMasterList()
    }*/

    if(this.oldSortField !==  this.sortField ||  this.oldSortOrder !== this.sortOrder)
    {
      this.applyFilter();
      this.getClientRequisitionContact()
    }
    this.oldSortField = this.sortField;
    this.oldSortOrder = this.sortOrder;
  }

  getLoggedInUserProfile()
  {
    this.loggedInUserProfile = this.sharedService.getLoggedInUserProfile();
  }

  getClientRequisitionContact(){
    this.appliedFilters.push({ field:"loggedInUserId", matchMode:"custom-equals", value:this.loggedInUserProfile.uid })
    this.searchParam = 
    {
      pageNo:this.pageNo,
      pageSize:this.pageSize,
      sortField:this.sortField,
      appliedFilters:this.appliedFilters,
      sortOrder:this.sortOrder
    };
    this.spinner.show(this.crcSearchSpinner);
    this.ClientRequisitionContactService.getClientRequisitionContact(this.searchParam).subscribe(data => {
      // this.appliedFilters = [];
      this.crcList =data;
      this.isshowpaginator=this.crcList.length>0?true:false;
      this.totalRecords = data[0].totalCount;
      this.spinner.hide(this.crcSearchSpinner);
    }, error => {
      console.log(error);
    })
  }

  clearFilter(table: Table) {
    for (let i = 0; i < this.filterCondition.length; i++) {
      if (this.table.filters[this.filterCondition[i].fieldName] != undefined) {
       this.table.filters[this.filterCondition[i].fieldName][0].value = null;
      }
    }
    table.clear();
    this.selectedStatus="";
    this.selectedStatusId=undefined;
    this.appliedFilters = [];
    // this.applyFilter();
    this.getClientRequisitionContact(); 
  }

  bindShowFilter() {
    this.showFilters = (this.showFilters ? false : true)
  }

  bindShowSorting() {
    this.showSorting = (this.showSorting ? false : true)
  }

  applyFilterNew(table: Table){
    this.filters=table.filters;
    this.applyFilter();
  }

  applyFilter(){
    if (Object.keys(this.filters).length > 1) {
      this.appliedFilters = [];
      for (let i = 0; i < this.filterCondition.length; i++) {
        if (this.filterCondition[i].type == "checkbox") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value == true) {
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: "true"
              })
            }
            else if (this.filters[this.filterCondition[i].fieldName][0].value == false) {
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: "false"
              })
            }
          }
        }
        else if (this.filterCondition[i].type == "basic") {
          console.log("filter type is basic");
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value !== null) {
              console.log("filter field name is "+[this.filterCondition[i].fieldName][0]);
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: this.filters[this.filterCondition[i].fieldName][0].value
              })
            }
          }
        }
        else if (this.filterCondition[i].type == "date") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            for (let j = 0; j <= this.filters[this.filterCondition[i].fieldName].length - 1; j++) {
              if (this.filters[this.filterCondition[i].fieldName][j].value !== null)
                this.appliedFilters.push({
                  field: this.filterCondition[i].fieldName,
                  matchMode: this.filters[this.filterCondition[i].fieldName][j].matchMode,
                  value: this.datepipe.transform(this.filters[this.filterCondition[i].fieldName][j].value,"MM-dd-yyyy")
                })
            }
          }
        }
        else if (this.filterCondition[i].type == "numeric") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value !== null)
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: this.filters[this.filterCondition[i].fieldName][0].value
              })
          }
        }
    }
    }
    this.appliedFilters.push({ field:"loggedInUserId", matchMode:"custom-equals", value:this.loggedInUserProfile.uid })
    if(this.startSearch == true || this.startSearch == false)
    {
      this.searchParam = 
       {
         pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedFilters,
         sortOrder:this.sortOrder
       };
       this.spinner.show(this.crcSearchSpinner);
       this.ClientRequisitionContactService.getClientRequisitionContact(this.searchParam).subscribe(data => {
         //this.appliedFilters = [];
         this.crcList =data;
         this.isshowpaginator=this.crcList.length>0?true:false;
         this.totalRecords = data[0].totalCount;
         this.spinner.hide(this.crcSearchSpinner);
       }, error => {
         console.log(error);
       })
    }
  }

  deleteConfirm(paramId:number){
    this.dialogPosition = 'topright';
    this.confirmationService.confirm({
      message: 'Do you want to delete this Vendor Client Assignment?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.ClientRequisitionContactService.deleteClientRequisitionContact(paramId).subscribe((data: any) => {
          this.getClientRequisitionContact();
          this.messageService.add({severity:'info', summary:'Confirmed', detail:'You have deleted the record'});
         });
      },
      reject: (type) => {
        switch(type) {
            case ConfirmEventType.REJECT:
                this.messageService.add({severity:'error', summary:'Rejected', detail:'You have rejected'});
            break;
            case ConfirmEventType.CANCEL:
                this.messageService.add({severity:'warn', summary:'Cancelled', detail:'You have cancelled'});
            break;
        }
      },
      key: "positionDialog"
    });
  }

  addCrcDetails(){
    this.isCrcView=false;
    this.InitialSetup();
    this.isCrcAdd = true;
    this.clientCompanyList = [];
    // this.getClientCompanyNotAdded();
    this.isCrcEdit=false;
    this.title="Client Requisition Contact Add";
    this.buttonLabel = "Save";
  }

  editCrcDetails(paramId: number)
  {
    this.InitialSetup(); 
    this.isCrcView=false;
    this.isCrcEdit = true;
    this.isCrcAdd = false;
    this.isCompanyNameSelected=true;
    this.title = "Client Requisition Contact Edit";
    this.buttonLabel = "Update";
    this.ClientRequisitionContactService.getClientRequisitionContactDetail(paramId).subscribe((data:ClientRequisitionContact) =>{
      this.crcForm.patchValue(data);
    },error => {
      console.log(error)
    })
  }

  showCrcDetails(paramId: number)
  {
    /*this.isCrcView=true;
    this.isCrcAvailability=false;
    this.ClientRequisitionContactService.getClientRequisitionContactDetail(paramId).subscribe((data:ClientRequisitionContact) =>{
      this.crcForm.patchValue(data);
    },error => {
      console.log(error)
    })*/
    
    this.ref = this.dialogService.open(ClientRequisitionViewModalComponent, {
      header: 'Client Requisition Contact Details',
      width: '50%',
      contentStyle: {"max-height": "500px", "overflow": "auto"},
      baseZIndex: 10000,
      data: {id: paramId}
    });
  }

  getClientCompanyList(){
    this.ClientRequisitionContactService.getClientCompanyList().subscribe(data => {
      this.vendorCompanyList = data;
      if(this.vendorCompanyList.length > 0){
        this.crcForm.get('vendorCompanyId').setValue(this.vendorCompanyList[0].companyId)
      }
    }, error => {
      console.log(error);
    })
  }

  // getClientCompanyNotAdded(){
  //   let companyId = this.crcForm.get('vendorCompanyId').value;
  //   this.ClientRequisitionContactService.getClientsNotAssignmentForVendorCompany(companyId).subscribe(data => {
  //     this.clientCompanyList = data;
  //     if(this.clientCompanyList.length > 0){
  //       this.crcForm.get('clientCompanyId').setValue(this.clientCompanyList[0].companyId)
  //     }else{
  //       this.crcForm.get('clientCompanyId').setValue(null)
  //     }
  //   },
  //   error => {
  //     console.log(error);
  //   })
  // }

  companyNameOnChange(id){
    this.clientCompanyList = [];
    this.isCompanyNameSelected=true;
    //this.getClientCompanyNotAdded();
    this.ClientRequisitionContactService.onCrcAvailabilityCheck(id).subscribe((data: any) => {
      console.log(data);
      if (data == true) {
        this.isCrcAvailability = true;
      }
      else {
        this.isCrcAvailability = false;
      }

    });
  }

  cancel(){
    this.isCrcAdd = false;
    this.isCrcEdit=false;
    this.isCrcView=false;
    this.isCrcAvailability=false;
  }

  /*save({value}: {value:ClientRequisitionContact}){
    this.spinner.show(this.crcSearchSpinner);
    this.loading = true;
    this.ClientRequisitionContactService.postClientRequisitionContact(value).subscribe(data=>{
      this.isCrcAdd = false;
      this.getClientRequisitionContact();
      this.loading = false;
      this.spinner.hide(this.crcSearchSpinner);
    }, error => {
      console.log(error);
    })
  }*/

  save({value}: {value:ClientRequisitionContact}){
    this.spinner.show(this.crcSearchSpinner);
    this.loading = true;
    if(value.contactId==0){
      value.createdBy = Number(this.loggedInUserProfile.uid);
      value.createdOn = new Date();
      this.ClientRequisitionContactService.postClientRequisitionContact(value).subscribe(data=>{
      this.isCrcAdd = false;
      this.getClientRequisitionContact();
    }, error => {
      console.log(error);
    })
   }
   else{
    this.ClientRequisitionContactService.updateClientRequisitionContact(value.contactId, value).subscribe(data => {
      this.isCrcEdit = false;
      this.getClientRequisitionContact();
    }, error => {
      console.log(error);
    })
   }
   this.loading = false;
   this.spinner.hide(this.crcSearchSpinner);
  }

  get crcFormControl() {
    return this.crcForm.controls;
  }

  contactPhoneUniqueNumbers(event) {
    let avoidString: Array<string> = ['(000) 000-0000','(111) 111-1111', '(222) 222-2222', '(222) 222-2222', '(333) 333-3333', '(444) 444-4444','(555) 555-5555','(666) 666-6666','(777) 777-7777','(888) 888-8888','(999) 999-9999'];
    let value = event.target.value;
    if(value.length<14)
    {
      this.isContactPhoneNumberValid = true;
    }
    else{
      this.isContactPhoneNumberValid = false;
    }
    if (avoidString.includes(value)) {
      this.isContactPhoneUniqueNumbers = true;
    }
    else {
      this.isContactPhoneUniqueNumbers = false;
    }

  }
  
  checkCompanyIdExists() {
    this.selectedCompanyId = this.crcForm.controls['clientCompanyId'].value;
    this.ClientRequisitionContactService.onCrcAvailabilityCheck(this.selectedCompanyId).subscribe((data: any) => {
      console.log(data);
      if (data == true) {
        this.isCrcAvailability = true;
      }
      else {
        this.isCrcAvailability = false;
      }

    });
  }

  exportClientRequisitionContact() {
    this.applyFilter();
    this.searchParam = 
     {
      pageNo:this.pageNo,
      pageSize:this.pageSize,
      sortField:this.sortField,
      appliedFilters:this.appliedFilters,
      sortOrder:this.sortOrder
     };
     this.ClientRequisitionContactService.ExportClientRequisitionContact(this.searchParam).subscribe(res => {
     var blob = new Blob([res.body], { type: res.body.type });
     const file = new File([blob],"ClientRequisitionContact.xlsx", { type: res.body.type });
     fs.saveAs(file);
     });
  }

  bindShowToggle() {
    this.showToggle = (this.showToggle ? false : true)
  }

  showAndHideColumn(event){
    this.selectedColumns = event.value;
  }

  isShowColumns(columnName){
    var tempColumn = this.selectedColumns.filter(col => col.value == columnName);
    if(tempColumn.length == 1){
      return true;
    }
    return false;
  }

  checkEditDeletePermission() {
    var isAdminAdd = this.sharedService.checkPermission("Admin_Add");
    var isAdminDelete = this.sharedService.checkPermission("Admin_Delete");
    if (isAdminAdd) {
      var editItem = {
        label:'Edit',
       icon:'pi pi-fw pi-pencil',
       command: e => this.editCrcDetails(this.selectedGridMenuItem.contactId)
      }
      this.items.push(editItem)
    }
    if(isAdminDelete){
      var deleteItem =  {
        label:'Delete',
        icon:'pi pi-fw pi-trash',
        command: e => this.deleteConfirm(this.selectedGridMenuItem.contactId)
       }
       this.items.push(deleteItem);
    }
  }

 getStatusOnChange(event)
 {
  this.selectedStatusId = event.value;
  this.selectedStatus=event.value;
 }

 clearStatus()
 {
  this.selectedStatus ="";
  this.selectedStatusId = undefined;
 }

}
